"use client";

import { Suspense, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";

import { isPostHogAnalyticsActive } from "@/lib/analytics/runtime";

function PostHogPageViewInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isPostHogAnalyticsActive() || !posthog.__loaded || !pathname) return;

    const query = searchParams.toString();
    const url =
      window.location.origin +
      pathname +
      (query.length > 0 ? `?${query}` : "");

    if (lastUrlRef.current === url) return;
    lastUrlRef.current = url;

    posthog.capture("$pageview", { $current_url: url });
  }, [pathname, searchParams]);

  return null;
}

/** Manual App Router pageviews — avoids duplicate history_change captures. */
export function PostHogPageView() {
  if (!isPostHogAnalyticsActive()) return null;

  return (
    <Suspense fallback={null}>
      <PostHogPageViewInner />
    </Suspense>
  );
}
